import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=355a3e7f&scoped=true&"
import script from "./LoaderComponent.vue?vue&type=script&lang=js&"
export * from "./LoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=355a3e7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a3e7f",
  null
  
)

export default component.exports